<template>
    <div>
        <b-row>
            <b-col cols="8">
                <div class="head">
                    <slot name="title(head)"></slot>
                </div>
                <div class="main">
                    <slot name="title"></slot>
                </div>
                <div class="foot">
                    <slot name="title(foot)"></slot>
                </div>
            </b-col>
            <b-col cols="2"></b-col>
            <b-col cols="2"></b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "overview-title",
};
</script>

<style scoped lang="scss">
@import "src/scss/custom";
.main {
    font-weight: bold;
    font-size: 24px;
}

.head,
.foot {
    color: $text-muted;
    font-size: $small-font-size;
}
</style>
